// removed by extract-text-webpack-plugin
module.exports = {"row":"index__row___j8m0n","label":"index__label___1s6y1","moreOptions":"index__moreOptions___EVHg0"};


//////////////////
// WEBPACK FOOTER
// ./src/components/page/TaskDetails/components/Fields/index.less
// module id = 1942
// module chunks = 3